// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YZlZc","option":"styles_option__NmXcH","active":"styles_active__7ggnT"};